import { render, staticRenderFns } from "./BudgetActivity.vue?vue&type=template&id=6c59416c"
import script from "./BudgetActivity.vue?vue&type=script&lang=js"
export * from "./BudgetActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports